// src/components/pages/campaigns/index.js
import { useEffect, useState, useCallback } from 'react';
import Layout from '../../layouts/default-logged-in';
import { ENTER_PAGE, trackEvent } from '../../../services/mixpanel';
import CampaignsList from '../../campaigns-components/campaigns-list';
import * as api from '../../../services/api';
import { errorToast } from '../../../utils/toaster';
import useLoadingHandler from '../../../hooks/use-loading-handler';

const INITIAL_STATE = [];

const ERROR_MESSAGES = {
  FETCH: 'Could not get your campaigns. Try refreshing your browser or contact support.',
  DELETE: 'Could not delete your campaign. Try refreshing your browser and trying again, or contact support.',
};

const CampaignsPage = () => {
  const [campaigns, setCampaigns] = useState(INITIAL_STATE);
  const { startLoading, stopLoading } = useLoadingHandler();

  const fetchCampaigns = useCallback(async () => {
    const key = 'fetch-campaigns';
    try {
      startLoading(key);
      const result = await api.campaigns.list();
      const campaignsArray = Array.isArray(result)
        ? result
        : result.campaigns || [];
      setCampaigns(campaignsArray);
    } catch (error) {
      errorToast({ message: ERROR_MESSAGES.FETCH });
    } finally {
      stopLoading(key);
    }
  }, []);

  const handleDeleteCampaign = useCallback(async (id) => {
    try {
      await api.campaigns.delete(id);
      setCampaigns(prev => prev.filter(campaign => campaign.id !== id));
    } catch (error) {
      errorToast({ message: ERROR_MESSAGES.DELETE });
    }
  }, []);

  useEffect(() => {
    trackEvent(ENTER_PAGE, 'CAMPAIGNS');
    fetchCampaigns();
  }, [fetchCampaigns]);

  return (
    <Layout>
      <CampaignsList 
        campaigns={campaigns} 
        onDeleteCampaign={handleDeleteCampaign}
      />
    </Layout>
  );
};

export default CampaignsPage;